module.exports = __webpack_public_path__ + "static/goosebumpsDON_logo-d01e788171ca05ecbcdb93dd39aa145b.png";